import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Blocks partner (non-Core) accounts from reaching app pages by direct URL.
// Mirrors the blockApps logic in AllApps.js and redirects them to /allapps.
const PartnerAppGuard = ({ children }) => {
  const headerDetials = useSelector((state) => state.headerMenuReducer);
  const loginDetials = useSelector((state) => state.loginReducer);

  const loginData = loginDetials?.loginDetials?.responseData || {};
  const isPartner =
    headerDetials?.isPartner ??
    headerDetials?.applicationPermisstionResponse?.isPartner ??
    loginData.isPartner ??
    false;
  const isJewelCloudCore =
    headerDetials?.isJewelCloudCore ??
    headerDetials?.applicationPermisstionResponse?.isJewelCloudCore ??
    loginData.isJewelCloudCore ??
    false;

  const blockApps = isPartner && !isJewelCloudCore;

  if (blockApps) {
    return <Navigate to="/allapps" replace />;
  }
  return children;
};

export default PartnerAppGuard;
